import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';
import { ProfileAction } from '@app/layout/common/profile/state/profile.action';
import { AuthService } from 'app/core/auth/auth.service';
import { isEmpty } from 'lodash';
import { map, of, switchMap, take } from 'rxjs';
import { filterUrlsByKeyword, getRoutesPaths } from '../utils/helpers';

export const AuthLanding: CanActivateFn | CanActivateChildFn = (_route, state) => {
  const router = inject(Router);
  const profileAction = inject(ProfileAction);
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        if (!authenticated) {
          const redirectURL = state.url === `/${ROUTE_NAMES.SIGN_OUT}` ? '' : `redirectURL=${state.url}`;
          const urlTree = router.parseUrl(`${ROUTE_NAMES.SIGN_IN}?${redirectURL}`);

          return of(urlTree);
        }
        profileAction.actions.get();
        return profileAction.actions.getSuccess$.pipe(
          take(1),
          map(({ profile }: any) => {
            const urls = getRoutesPaths(router.config);
            const existedPages = filterUrlsByKeyword(urls, profile?.landing_page);
            if (isEmpty(existedPages)) {
              return router.createUrlTree([`/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.COMPANY}`]);
            }
            return router.createUrlTree([existedPages[0] || `/${ROUTE_NAMES.DATABASE}/${ROUTE_NAMES.COMPANY}`]);
          })
        );
      })
    );
};
